import cx from 'classnames';
import { get, isEmpty } from 'lodash';
import { Check } from 'react-bootstrap-icons';

/**
 * @param {import('models/documents.models').DocumentVariant} variant
 * @param {function(id: number): void} [toggleVariant]
 * @param {boolean} active
 * @param {boolean} toggleEnabled
 */
export function VariantLabel({ variant, toggleVariant, active = false, toggleEnabled = true }) {
    const color = getColor();
    const backgroundColor = getBackgroundColor();

    return (
        <div
            className={cx('variant-label', { active, 'variant-label-clickable': toggleEnabled })}
            onClick={() => {
                if (toggleEnabled) {
                    toggleVariant(variant.id);
                }
            }}
            style={{
                '--color': color,
                '--bg-color': backgroundColor,
                '--hover-bg-color': `color-mix(in srgb, ${backgroundColor}, black 15%)`,
            }}
        >
            <>
                {active && <Check size={15} className="flex-shrink-0" style={{ marginRight: 2, marginLeft: -5 }} />}
                {!isEmpty(variant.prefix) && <span className="variant-label-prefix">{variant.prefix}</span>}
                <span className="variant-label-title">{variant.name}</span>
            </>
        </div>
    );

    function getColor() {
        const color = get(variant, 'parent.color', '#255478');

        if (isEmpty(color)) {
            return '#255478';
        }

        return color;
    }

    function getBackgroundColor() {
        const backgroundColor = get(variant, 'parent.backgroundColor', '#eef1ff');

        if (isEmpty(backgroundColor)) {
            return '#eef1ff';
        }

        return backgroundColor;
    }
}
